/* eslint-disable */
export default {
  searchPlaceholder: 'Zoeken...',
  refresh: 'Vernieuwen',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
